<template>
  <div id="home">
    <div class="px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
      <h1 class="display-4 mr-2">Status</h1>
    </div>

    <div class="loading" v-show="loading">
      <Loading />
    </div>

    <div v-show="!loading">
      <ul class="nav nav-tabs my-4">
        <li class="nav-item">
          <a class="nav-link clickable" v-bind:class="{ active: (''==selected) }" v-on:click="selected=''">All types</a>
        </li>
        <li v-for="type in types" v-bind:key="type" class="nav-item">
          <a class="nav-link clickable" v-bind:class="{ active: (type==selected) }" v-on:click="select(type)">{{type}}</a>
        </li>
      </ul>

      <div class="row">
        <div class="col-md-12 col-lg-9">
          <div class="card-deck mb-3">
            <div class="card mb-4 shadow-sm">
              <div class="card-header">
                <h4 class="my-0 font-weight-normal">
                  <grid-icon size="1.0x" style="transform: translateY(-3px)" class="mr-2"></grid-icon> Grid
                </h4>
              </div>
              <div class="card-body">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th>key<span class="field">.field</span></th>
                      <th class="d-none d-md-table-cell" scope="col" v-for="key in keys" v-bind:key="key">{{key}}</th>
                      <th class="d-table-cell d-md-none">data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, id) in gridShowLimited" v-bind:key="id" v-bind:class="{'table-dark': row.age > 96, 'table-danger': row.age > 48, 'table-warning': row.age > 24, 'table-success': row.age <= 24}">
                      <td><a class="key clickable" v-on:click="$parent.browse('latest/10/'+row['key'])">{{row['key']}}<span class="field" v-if="row['field'] != null">.{{row['field']}}</span></a></td>
                      <td class="d-none d-md-table-cell" v-for="key in keys" v-bind:key="key">
                        <span v-if="row[key] == null" v-bind:title="row[key]">null</span>
                        <span v-if="JSON.stringify(row[key]).startsWith('{')" style="cursor: help;" v-bind:title="JSON.stringify(row[key], null, 2)">{{row[key].src}}</span>
                        <span v-else>{{row[key]}}<span v-show="key=='age'">h</span></span>
                      </td>
                      <td class="d-table-cell d-md-none">
                        <div v-for="key in keys" v-bind:key="key">
                          {{row[key]}}<span v-show="key=='age'">h</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="alert alert-warning" role="alert" v-show="isLimited">
                  <h4 class="alert-heading">Display Limit</h4>
                  <p>Showing only the first {{limit}} rows.</p>
                  <hr>
                  <p class="mb-0">Show <a href="#" class="alert-link" v-on:click="limit = grid.length">all</a> rows.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-lg-3">
          <div class="card-deck mb-3">
            <div class="card mb-4 shadow-sm">
              <div class="card-header">
                <h4 class="my-0 font-weight-normal">
                  <bar-chart-2-icon size="1.0x" style="transform: translateY(-3px)" class="mr-2"></bar-chart-2-icon> Metrics
                </h4>
              </div>
              <div class="card-body">

                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Metric</th>
                      <th class="text-right" scope="col">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Records</td>
                      <td class="text-right"><strong>{{records}}</strong></td>
                    </tr>
                    <tr class="clickable" v-on:click="filter = (row => true || row)">
                      <td>Keys</td>
                      <td class="text-right"><strong>{{gridShow.length}}</strong></td>
                    </tr>
                    <tr class="clickable" v-bind:class="{'table-success': fresh > 0}" v-on:click="filter = (row => row.age <= 24)">
                      <td>New (&leq;&nbsp;24h)</td>
                      <td class="text-right"><strong>{{fresh}}</strong></td>
                    </tr>
                    <tr class="clickable" v-bind:class="{'table-warning': old > 0}" v-on:click="filter = (row => row.age > 24 && row.age <= 48)">
                      <td>Old (&gt;&nbsp;24h)</td>
                      <td class="text-right"><strong>{{old}}</strong></td>
                    </tr>
                    <tr class="clickable" v-bind:class="{'table-danger': stale > 0}" v-on:click="filter = (row => row.age > 48 && row.age <= 96)">
                      <td>Stale (&gt;&nbsp;48h)</td>
                      <td class="text-right"><strong>{{stale}}</strong></td>
                    </tr>
                    <tr class="clickable" v-bind:class="{'table-dark': dead > 0}" v-on:click="filter = (row => row.age > 96)">
                      <td>Dead (&gt;&nbsp;96h)</td>
                      <td class="text-right"><strong>{{dead}}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GridIcon,
    BarChart2Icon
  } from 'vue-feather-icons'
  import Loading from './Loading.vue'

  export default {
    name: 'Home',
    data: function() {
      return {
        grid: [],
        keys: ['latest', 'age', 'count', 'meta'],
        limit: 50,
        selected: '',
        filter: (row => row || true),
        types: []
      };
    },
    computed: {
      gridShow: function() {
        var result = this.grid;

        if (this.selected) {
          result = this.grid.filter(row => row.type == this.selected)
        }

        return result;
      },
      gridFiltered: function() {
        return this.gridShow.filter(this.filter);
      },
      gridShowLimited: function() {
        return this.gridFiltered.slice(0, this.limit);
      },
      isLimited: function() {
        return this.limit < this.gridFiltered.length;
      },
      records: function() {
        return this.gridShow.reduce((total, row) => total + parseInt(row.count), 0);
      },
      fresh: function() {
        return this.gridShow.filter(row => row.age <= 24).length;
      },
      old: function() {
        return this.gridShow.filter(row => row.age > 24).length - this.stale - this.dead;
      },
      stale: function() {
        return this.gridShow.filter(row => row.age > 48).length - this.dead;
      },
      dead: function() {
        return this.gridShow.filter(row => row.age > 96).length;
      }
    },
    methods: {
      select: function(type) {
        this.filter = (row => true || row);
        this.selected = type;
      }
    },
    created: function() {
      const self = this;

      self.loading = true;

      fetch("https://data.silversky.dev/v1/status")
        .then(response => response.json()).then(json => {
          // Table
          self.grid = json;

          self.grid.forEach(row => {
            if (!self.types.includes(row.type)) {
              self.types.push(row.type);
            }
          })

          self.types.sort();

          self.loading = false;
        });

    },
    components: {
      Loading,
      GridIcon,
      BarChart2Icon
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .key {
    color: black;
  }

  .field {
    color: #999;
  }

  .clickable {
    cursor: pointer;
  }

  .clickable:hover {
    text-decoration: underline;
  }
</style>
